import { GenerateScenarioEquityValueExpressionParams } from './types';

const generateWeightedEquityValueExpression = (params: GenerateScenarioEquityValueExpressionParams) => {
  const { approachRowNumber, columnLegend, equityValueColumnLegend } = params;

  return `(${equityValueColumnLegend}${approachRowNumber} * ${columnLegend}${approachRowNumber})`;
};

export default generateWeightedEquityValueExpression;
